<template>
    <div class="picture__container">
        <img
                :src="`${$store.state.apiUrl}/images/pictures/small/${picture.path.split('.')[0]}.webp`"
                class="picture"
                :alt="`hike on earth - ${picture.description}`"
                @click="zoomPicture"
        >
        <div class="picture__action">
            <router-link v-if="$store.state.user.role === 'admin'" :to="{name:'Edit', params:{collection:'pictures', id:picture._id}}" class="picture__button btn--orange u-margin-right-1rem">
                edit
            </router-link>
            <button class="picture__button picture__like  picture__action--item" :class="{'picture__like--liked': pictureData.likes.includes($store.state.user._id)}" @click="likePic(picture._id)">
                <div class="picture__like--figure">{{pictureData.countLikes}}</div>
                <Svg className="picture__like--logo" icon="like"/>
            </button>
        </div>

        <router-link :to="{name:'User', params:{slug:picture.user._id}}" class="picture__button picture__legend">
            <img :src="`${$store.state.apiUrl}/images/profil/small/${picture.user.profilePicture.split('.')[0]}.webp`" :alt="`user picture ${picture.user.name}`" class="picture__legend--img">
            <div class="picture__legend--name">
                {{picture.user.name}}
            </div>
        </router-link>
        <router-link :to="{ name : 'Trail' , params: {slug: picture.trail.slug} }" v-if="picture.trail.name" class="picture__button picture__trail">
            <div class="picture__trail--name">
                {{picture.trail.name}}
            </div>
        </router-link>
</div>
  
</template>

<script>
import Svg from '../utils/Svg';
import { ref } from 'vue';
import { useStore } from 'vuex';

import {likePicture} from '@/composables/pictures/interaction';

export default {
    components:{Svg},
    props:{
            picture: Object,
    },
    setup(props){
        const store = useStore();
        const pictureData = ref(props.picture);

        const likePic = async (id) => {
            const userLike = pictureData.value.likes.includes(store.state.user._id)
            const res = await likePicture(store, id, userLike)

            //Like
            if(res){
                //Like counter
                if(res.data.like) {
                    pictureData.value.likes.push(store.state.user._id)
                    pictureData.value.countLikes ++;
                    
                }
                else{
                    pictureData.value.likes = pictureData.value.likes.filter(el=>el !== store.state.user._id);
                    pictureData.value.countLikes --;
                }

            }
        }

        const zoomPicture = () => {
            store.state.popup.display = true;
            store.state.popup.data={
                name:"picture",
                data: pictureData.value
            }
        }

        return {
            likePic,
            pictureData,
            zoomPicture
        }
    }
}
</script>

<style lang="scss">
@import '@/style/main';
@import '@/style/components/picture';

</style>